import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';

import Header from './Header/Component';
import Footer from './Footer';

const useStyles: any = makeStyles((theme: any) => ({
  layOutRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'center',
    },
    minHeight: '95vh',
  },
  layOutMainContentContainer: {
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(3, 2),
    },
    [theme.breakpoints.up('sm')]: {
      width: 550,
      margin: '0 auto',
    },
  },
  layOutHeader: {
    [theme.breakpoints.down('sm')]: {
      backgroundColor: `${theme.palette.common.white} !important`,
      border: `1px solid ${theme.palette.grey[300]}`,
      padding: theme.spacing(0, 0, 1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 0),
    },
  },
}));

interface Props {
  children: React.ReactNode;
}

const BaseLayout = (props: Props) => {
  const classes = useStyles();
  const { children } = props;

  return (
    <>
      <Grid className={classes.layOutRoot}>
        <Box className={classes.layOutHeader}>
          <Header />
        </Box>
        <Grid className={classes.layOutMainContentContainer}>{children}</Grid>
      </Grid>
      <Footer />
    </>
  );
};

export default withWidth()(BaseLayout);
